<template lang="html">
  <section
    class="game-stats"
    :class="{ visible: gameStatsVisible }"
    @click="$store.dispatch('clickGameStatsPanel')"
  >
    <ul v-if="shoe" class="stats-list">
      <li>Deck penetration: {{ shoe.penetration }}%</li>
      <li v-if="settings.checkDeviations">
        Hi-Lo count: {{ shoe.hiLoRunningCount }} (<b>{{
          shoe.hiLoTrueCount
        }}</b>
        true count)
      </li>
      <SessionMovesStats tag="li" />
    </ul>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SessionMovesStats from '@/components/SessionMovesStats';
import alignWithAppWidth from '@/utils/align-with-app-width';
import mobileDetection from '@/mixins/mobile-detection';

export default {
  name: 'GameStats',

  components: {
    SessionMovesStats,
  },

  mixins: [mobileDetection],

  computed: {
    ...mapState(['shoe', 'gameStatsVisible']),
    ...mapGetters(['settings']),
  },

  watch: {
    gameStatsVisible: {
      immediate: true,
      handler(gameStatsVisible) {
        if (gameStatsVisible) {
          this.positionStats();
        }
      },
    },
  },

  mounted() {
    window.addEventListener('resize', this.positionStats);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.positionStats);
  },

  methods: {
    positionStats() {
      alignWithAppWidth(this.$el, { side: 'left', margin: this.isMobile });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/unstyled-list';

.game-stats {
  z-index: map-get($z-index, 'modal');
  position: sticky;
  top: map-get($app, 'spacing');
  width: 100%;
  opacity: 0;
  transform: translateY(-10px);
  transition: map-get($transition-speeds, 'fast') ease-in;
  transition-property: opacity, transform;

  align-self: flex-start;

  &.visible {
    opacity: 1;
    transform: translateY(0px);
  }

  &:not(.visible) {
    pointer-events: none;
  }
}

.stats-list {
  @include unstyled-list;

  flex-direction: column;
  background-color: map-get($colors, 'blue-dark');
  font-size: 0.9em;
  padding: (map-get($app, 'spacing') * 0.75) map-get($app, 'spacing');
  border-radius: map-get($app, 'border-radius');
}

.session-moves-stats {
  $spacing: 0.75rem;

  border-top: 1px solid map-get($colors, 'faded-background-2x');
  margin-top: $spacing;
  padding-top: $spacing;
}

@media all and (min-width: map-get($breakpoints, 'phone')) {
  .game-stats {
    width: auto;
  }
}
</style>
